import React, { useState, useEffect } from 'react'
import {Button} from "react-bootstrap";
import "../layout/CommandeInformation.css"
import { Database } from "./Firebase/Firebase"
import {BiUser,BiPhone} from "react-icons/bi";
import {FaShippingFast} from "react-icons/fa";
import { useHistory } from "react-router-dom";
import swal from 'sweetalert';
import NavBar from './NavBar'
import Footer from './Footer'

const ConfirmCommande = () => {
    const [fetched, setFetched] = useState()
    let history = useHistory()
    useEffect(() => {
        setFetched(JSON.parse(localStorage.getItem('Article')))
    }, [])
    const [nomComplet, setNomComplet] = useState("")
    const [ville, setVille] = useState("")
    const [phone, setPhone] = useState()

    const getCommande = (e) => {
        e.preventDefault();
        const article = Database.database().ref("Commande")
        const CommandeDetails = {
            fetched,
            nomComplet,
            ville,
            phone
        };
        article.push(CommandeDetails);
        setNomComplet("")
        setVille("")
        setPhone("")
        swal({

            title: "شكراً لك على ثقتك في متجرنا",
            text: "سوف يتصل بيك أحد موظفينا لتأكيد طلبك",
            icon: "success",
            button: "Ok",
        });
        history.push("/")
    }

    return (
        <>
        <NavBar/>
            <div className="wrapper">
                <div className="payment">
                    <div className="payment-logo">
                        <p>p</p>
                    </div>
                    <h2 className="arabicTitle">المرجو ملأ الاستمارة</h2>
                    <form className="form">
                        <div className="carde space icon-relative">
                            <label className="label">:الاسم الكامل</label>
                            <input onChange={(e)=>setNomComplet(e.target.value)} value={nomComplet} type="text" className="input" name="name" placeholder="الاسم الكامل" />
                            <BiUser className="User"/>
                        </div>
                        <div className="carde space icon-relative">
                            <label className="label">:المدينة</label>
                            <input onChange={(e)=>setVille(e.target.value)} value={ville} type="text" className="input" name="city" placeholder="المدينة" />
                            <FaShippingFast className="User"/>
                        </div>
                        <div className="carde space icon-relative">
                            <label className="label">:رقم الهاتف</label>
                            <input onChange={(e)=>setPhone(e.target.value)} value={phone} type="text" className="input" name="phone" placeholder="رقم الهاتف" />
                            <BiPhone  className="User" />
                        </div>
                        <Button onClick={getCommande} type="submit" className="btne">
                        إضغط هنا لتأكيد طلبك    
                        </Button>
                    </form>
                </div>
            </div>
        </>
    )
}

export default ConfirmCommande
